import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { DropdownOption } from './DailyReviewInterfaces';
import { Button, Form, Spinner } from 'react-bootstrap';
import dayjs from 'dayjs';

export interface SearchBarProps {
    stateDropdown: DropdownOption[] | undefined;
    profitCenterDropdown: DropdownOption[] | undefined;
    clearProfitCenterDropdown(): void;
    getStatesForDropdown(): void;
    getProfitCentersByState(stateId: number): void;
    date: Date | undefined;
    setDate(date: Date): void;
    getDailyReviewSummaryData(profitCenter: DropdownOption | null | undefined): void;
    searching: boolean;
}

const SearchBar: React.FunctionComponent<SearchBarProps> = (props: SearchBarProps) => {
    const { stateDropdown, profitCenterDropdown, clearProfitCenterDropdown, getStatesForDropdown, getProfitCentersByState, date, setDate, getDailyReviewSummaryData, searching } = props;

    //  U S E S T A T E S
    const [state, setState] = useState<DropdownOption>();
    const [profitCenter, setProfitCenter] = useState<DropdownOption | null>();

    //  F U N C T I O N S
    const selectState = (state : DropdownOption) => {
        setState(state);
        setProfitCenter(null);

        getProfitCentersByState(state.id);        
    };

    return (
        <div className='daily-review-search-container'>
            <div className='daily-review-search-section-wrapper'>
                <Select
                    placeholder={"Select a State"}
                    getOptionLabel={(item: DropdownOption) => item.label}
                    getOptionValue={(item: DropdownOption) => item.id}
                    options={stateDropdown}
                    value={state}
                    onChange={(item: DropdownOption) => { selectState(item); clearProfitCenterDropdown(); }}
                    isDisabled={stateDropdown?.length == 0 || stateDropdown == null}
                />
            </div>
            <div className='daily-review-search-section-wrapper'>
                <Select
                    isDisabled={state == null || profitCenterDropdown == null || profitCenterDropdown?.length == 0}
                    placeholder={"Select a Profit Center"}
                    getOptionLabel={(item: DropdownOption) => item.label}
                    getOptionValue={(item: DropdownOption) => item.id}
                    options={profitCenterDropdown}
                    value={profitCenter}
                    onChange={(item: DropdownOption) => setProfitCenter(item)}
                />
            </div>
            <div className='daily-review-search-section-wrapper'>
                <Form.Control
                    type="date"
                    onChange={(e: any) => setDate(e.target.value)}
                    name='dailyReviewDate'
                    max={dayjs().format('YYYY-MM-DD')}
                />
            </div>
            <div className='daily-review-search-button-wrapper'>
                <Button onClick={() => getDailyReviewSummaryData(profitCenter)} variant='secondary' disabled={state == null || date == null || profitCenter == null || searching}>
                    View
                    {searching && (<Spinner animation='border' size='sm' className='daily-review-spinner' />)}
                </Button>
            </div>                        
        </div>
    )
}

export default SearchBar;